import { render, staticRenderFns } from "./theater.vue?vue&type=template&id=2fb208d6"
import script from "./theater.vue?vue&type=script&lang=js"
export * from "./theater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports